import { render } from "./UnilevelHistory.vue?vue&type=template&id=efdcfa52"
import script from "./UnilevelHistory.vue?vue&type=script&lang=ts"
export * from "./UnilevelHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script